(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[95597],{

/***/ 95597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ mainListing; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/lib/shared/config.ts
var config = __webpack_require__(98218);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/antiviruschoice/offer/offer.module.scss
var offer_module = __webpack_require__(74421);
var offer_module_default = /*#__PURE__*/__webpack_require__.n(offer_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/shared/affiliateOfferUrl/index.tsx + 1 modules
var affiliateOfferUrl = __webpack_require__(25416);
;// CONCATENATED MODULE: ./src/components/antiviruschoice/offer/index.tsx





const Offer = ({ id , offer , zone  })=>{
    const { image , logo , description , features , attributes , price , oldPrice , discount , currency , title ,  } = offer;
    const wantedAttributes = [
        "security level",
        "free version",
        "money back guarantee",
        "firewall",
        "included vpn", 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(affiliateOfferUrl/* default */.Z, {
        zone: zone,
        className: `flex relative p-4 lg:p-8 border-b-2 md:border-2 flex-col justify-between lg:my-6 ${(offer_module_default())["listing-item"]}`,
        offer: offer,
        target: "_blank",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `hidden lg:flex absolute top-0 left-0 w-12 h-12 ${(offer_module_default()).gray} items-center font-bold text-2xl justify-center`,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: id + 1
                })
            }),
            discount && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `${(offer_module_default()).corner} px-6 py-2 lg:p-0 absolute bottom-4 lg:right-0 lg:top-0 font-bold`,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "absolute text-sm",
                    children: [
                        "-",
                        discount
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col lg:flex-row lg:mb-5 top",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col-reverse justify-center lg:items-center lg:flex-row lg:p-3 w-4/12 mr-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "max-w-200px hidden mr-6 lg:block w-28",
                                children: image && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: `${image?.fullPath}`,
                                    width: 112,
                                    height: 170,
                                    alt: `${title} image`
                                })
                            }),
                            logo && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "max-w-200px lg:mb-0 mb-2",
                                src: `${logo?.fullPath}`,
                                alt: `${title} logo`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col lg:w-6/12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "font-bold mb-6 text-sm",
                                children: description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: " flex-col hidden lg:flex text-sm",
                                children: features.map((item, idx)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "flex items-center mb-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/tick.svg",
                                                className: "w-4 h-3 mr-2",
                                                alt: "check"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: item
                                            })
                                        ]
                                    }, idx);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex lg:flex-col justify-end lg:justify-center lg:ml-auto relative last",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col-reverse items-center justify-center lg:flex-row mr-1",
                                children: [
                                    Boolean(oldPrice) && Number(oldPrice) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: `text-sm lg:text-base ml-2 ${(offer_module_default()).strike}`,
                                        children: [
                                            currency,
                                            oldPrice
                                        ]
                                    }),
                                    Boolean(price) && Number(price) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: `${(offer_module_default()).red} ml-2 font-bold lg:text-2xl`,
                                        children: [
                                            currency,
                                            price
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: `${(offer_module_default()).button} flex items-center justify-center lg:text-xl lg:py-2  w-32 lg:w-40 rounded-md font-bold relative`,
                                children: [
                                    "Visit Site",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "w-4 ml-2 lg:w-5",
                                        src: "/assets/double-arrow.svg",
                                        alt: ""
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex text-sm",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: `${(offer_module_default())["button-right"]} items-center py-2 px-4 rounded hidden relative lg:flex justify-center w-4/12 mr-6`,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "View Offer"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "w-4",
                                src: "/assets/right-arrow2.svg",
                                alt: ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: `${(offer_module_default()).yellow} justify-around text-xs hidden py-3 lg:flex rounded-md w-8/12 font-poppins`,
                        children: Object.keys(attributes).map((attributeKey, idx)=>{
                            return wantedAttributes.includes(attributeKey?.toLocaleLowerCase()) && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            attributeKey,
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-bold",
                                                children: attributes[attributeKey]?.toLowerCase()?.includes("true") ? "Available" : attributes[attributeKey]
                                            })
                                        ]
                                    })
                                })
                            }, idx);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var offer = (Offer);

// EXTERNAL MODULE: ./src/components/antiviruschoice/mainListing/mainListing.module.scss
var mainListing_module = __webpack_require__(46676);
var mainListing_module_default = /*#__PURE__*/__webpack_require__.n(mainListing_module);
;// CONCATENATED MODULE: ./src/components/antiviruschoice/mainListing/index.tsx





const MainListing = ({ listing , isComparison  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: `md:px-4 pb-10 ${(mainListing_module_default()).listing}`,
        children: listing && listing.map((item, idx)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(offer, {
                zone: isComparison ? config/* affiliateOfferZones.COMPARISON_PAGE */.ZR.COMPARISON_PAGE : config/* affiliateOfferZones.HOME_PAGE */.ZR.HOME_PAGE,
                id: idx,
                offer: item
            }, idx);
        })
    });
};
/* harmony default export */ var mainListing = (MainListing);


/***/ }),

/***/ 46676:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listing":"mainListing_listing__dvKD4"};

/***/ }),

/***/ 74421:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"offer_gray__kWXXj","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"offer_red__kKDAc","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"offer_yellow__mt4CN","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"offer_button__YNAtK","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","corner":"offer_corner__r9meS","strike":"offer_strike__Hohn6","listing-item":"offer_listing-item__jiEVK","button-right":"offer_button-right__phEuE"};

/***/ })

}]);